import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ArrowUp, LucideIconData } from 'lucide-angular';
import { IconComponent } from '../../shared/ui/icon/icon.component';

const SCROLL_THRESHOLD = 400;

@Component({
  selector: 'app-back-to-top',
  imports: [IconComponent],
  template: `
    <button
      class="back-to-top"
      [class.back-to-top--visible]="isVisible()"
      (click)="scrollToTop()"
      aria-label="Volver al inicio"
      type="button"
    >
      <app-icon [icon]="arrowUpIcon" [size]="24" />
    </button>
  `,
  styleUrl: './back-to-top.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BackToTopComponent {
  protected readonly isVisible = signal(false);
  protected readonly arrowUpIcon: LucideIconData = ArrowUp;

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() => {
      if (!this.isBrowser) return;

      const onScroll = (): void => {
        this.isVisible.set(window.scrollY > SCROLL_THRESHOLD);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      this.destroyRef.onDestroy(() =>
        window.removeEventListener('scroll', onScroll),
      );
    });
  }

  protected scrollToTop(): void {
    if (!this.isBrowser) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
